<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold text-red-400 my-5">{{ item[groupByFilters(form.getFieldValue('group_by'))] }}</div>
            <a-table :dataSource="item.matters" :columns="columns" :pagination="false" >
              <span slot="description" slot-scope="text,record">
                {{ limitTextTask(record.description) }}
              </span>
              <div slot="is_billable" slot-scope="text,record">
                <feather-icon v-if="record.is_billable" icon="CheckIcon" svg-classes="text-success w-5 h-5"></feather-icon>
                <feather-icon v-else icon="XIcon" svg-classes="text-danger w-5 h-5"></feather-icon>
              </div>
              <div slot="status" slot-scope="text,record">
                <ATag :color="statusMatter(record.status).color">
                  {{ statusMatter(record.status).title }}
                </ATag>
              </div>
            </a-table>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Originating Lawyer">
              <a-radio-group v-decorator="['which_origination',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeOriginating">
                <a-radio :style="radioStyle" :value="1">
                  All Originating Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Originating Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="originating_value === 2"
              url="/account/list/"
              label="User"
              field="origination"
              :required="false"
              method="get"
              placeholder="Find A User"
              mode="multiple"
              class="w-full self-end"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group v-decorator="['which_responsible',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeResponsible">
                <a-radio :style="radioStyle" :value="1">
                  All Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="responsible_value === 2"
              url="/account/list/"
              label="Responsible"
              field="responsible"
              :required="false"
              method="get"
              placeholder="Find A User"
              mode="multiple"
              class="w-full self-end"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client/Matter">
              <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
                <a-radio :style="radioStyle" :value="3">
                  Specific Matter
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 3"
              :required="false"
              url="/matter/query/"
              :options="optionSearchMatter"
              class="self-end mt-8 md:mt-0 w-full"
              :is_include_matter="true"
              @selectSearch="handleSearch"
            />
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="self-center mt-8 md:mt-0 w-full"
              :is_include_matter="false"
              @selectSearch="handleSearch"
            />
          </div>
          <a-form-item label="Group Results By">
            <a-select v-decorator="['group_by',{initialValue: 1,rules: [{ required: false }] }]">
              <a-select-option :value="1">
                Client
              </a-select-option>
              <a-select-option :value="2">
                Responsible Lawyer
              </a-select-option>
              <a-select-option :value="3">
                Owner
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Matter Status">
            <a-select v-decorator="['status',{rules: [{ required: false }] }]" allowClear>
              <a-select-option :value="1">
                Open
              </a-select-option>
              <a-select-option :value="2">
                Closed
              </a-select-option>
              <a-select-option :value="3">
                Pending
              </a-select-option>
            </a-select>
          </a-form-item>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
          <DateRangeComponent :dateForm="form" class="mt-4"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','MatterReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Matter',
    dataIndex: 'title',
    key: '1',
  },
  {
    title: 'Practice Area',
    dataIndex: 'practice_area.title',
    key: '2',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '3',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Billable',
    dataIndex: 'is_billable',
    key: '4',
    scopedSlots: { customRender: 'is_billable' },
  },
  {
    title: 'Reference',
    dataIndex: 'reference_code',
    key: '5',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: '6',
    scopedSlots: { customRender: 'status' },
  },
]


export default {
  name: "ComponentByUser",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      user_value: null,
      responsible_value: null,
      originating_value: null,
      checked_matter_client: null,
      title:'User Productivity',
      columns,
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  methods:{
    handleChangeResponsible({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ responsible: [] })
      this.responsible_value = value
    },
    handleChangeOriginating({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ origination: [] })
      this.originating_value = value
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query     = []
            if (values.contact) query.push({ field:'client__id', condition: '=', value: values.contact, operation: 'and' })
            if (values.matter)  query.push({ field:'id', condition: '=', value: values.matter, operation: 'and' })
            if (values.status)  query.push({ field:'status', condition: '=', value: values.status, operation: 'and' })
            if (values.responsible && values.responsible.length) query.push({ field:'responsible__id', condition: 'in', value: values.responsible, operation: 'and' })
            if (values.origination && values.origination.length) query.push({ field:'origination__id', condition: 'in', value: values.origination, operation: 'and' })
            if (values.practice_area) query.push({ field:'practice_area', condition: '=', value: values.practice_area, operation: 'and' })
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const {data}    = await axios.post('matter/report/matters',{ group_by: values.group_by , query : query.length ? query : undefined })
            this.visibleRes = true
            this.result     = Object.values(data)
          }catch (e) {
            this.visibleRes = false
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
    statusMatter(sts){
      if(sts === 1)
        return {title:'Open',color:'green'}
      else if(sts === 2)
        return {title:'Close',color: 'red'}
      else if(sts === 3)
        return {title:'Pending',color:'yellow'}
    },
    groupByFilters(group) {
      if (group === 1) return 'contact'
      if (group === 2) return 'responsible'
      if (group === 3) return 'owner'
    },
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
